export const MAX_DISTANCE = 20;
export const MIN_DISTANCE = 5;
export const NUMBER_OF_LINES = 183;
export const LINE_HEIGHT = 50;
export const LINE_SPACING = 3.5;
export const LINE_WIDTH = 1.5;
export const INPUT_PATTERN = '([01]?[0-9]|2[0-3])?:[0-5][0-9]:[0-5][0-9]';
